<!--
| Base.viewer
| 带v-app的基本窗口页面，用于统一管理公共组件（例如Snackbar）。
-->
<template>
  <v-app>
    <v-snackbar
    app
      v-model="$store.state.OPTIONS.snackbar.show"
      :color="$store.state.OPTIONS.snackbar.color"
      :left="$store.state.OPTIONS.snackbar.left"
      :right="$store.state.OPTIONS.snackbar.right"
      :top="$store.state.OPTIONS.snackbar.top"
      :bottom="$store.state.OPTIONS.snackbar.bottom"
      >{{ $store.state.OPTIONS.snackbar.text.indexOf('@') === -1 ? $store.state.OPTIONS.snackbar.text : $t(`all.snackbar${$store.state.OPTIONS.snackbar.text}`)}}</v-snackbar
    >
    <slot></slot>
  </v-app>
</template>

<script>
import Snackbar from "./snackbar";
export default {
  name: "viewer",
  components: {
    Snackbar,
  },
};
</script>

<style>
</style>